import { TSelectedSkuItem, TSkuItem } from "@elixir/types";
import { Modal } from "antd";
import { CreateServicePopupUi } from "ui";

const CreateEditServicePopup = ({
  isModalOpen = false,
  skuItem,
  onClose,
  handleCreateEditSumbit,
  isCreateLoading,
  isUpdateLoading,
}: {
  isModalOpen: boolean;
  skuItem?: TSkuItem;
  onClose: () => void;
  handleCreateEditSumbit: ({ service_name, price }: TSelectedSkuItem) => void;
  isCreateLoading?: boolean;
  isUpdateLoading?: boolean;
}) => {
  return (
    <Modal
      open={isModalOpen}
      style={{
        padding: 0,
        overflow: "hidden",
        background: "transparent",
        minWidth: "40vw",
      }}
      className="modal-rounded-8"
      bodyStyle={{
        backgroundColor: "transparent",
        padding: 0,
        overflow: "hidden",
      }}
      footer={null}
      closable={false}
      destroyOnClose={true}
    >
      <CreateServicePopupUi
        popupState={skuItem ? "Update" : "Create"}
        defaultName={skuItem?.service_name}
        defaultPrice={skuItem?.price}
        onClose={onClose}
        onSubmitClick={handleCreateEditSumbit}
        isSubmitting={isCreateLoading || isUpdateLoading}
      />
    </Modal>
  );
};

export default CreateEditServicePopup;
